import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { isDefined } from '@trimble-gcs/common';
import { ExtensionType } from 'trimble-connect-workspace-api';
import { AppRoute } from '../app-route';
import { ConnectService } from '../connect/connect.service';
import { RouteState } from './route.state';

export const redirectGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const store = inject(Store);
  const router = inject(Router);
  const connectService = inject(ConnectService);
  const workspace = await connectService.getWorkspace();
  const extensionType = isDefined(workspace) ? await connectService.getExtensionType() : null;

  const appRoute =
    extensionType === ExtensionType.Viewer
      ? AppRoute.Connect3d
      : store.selectSnapshot(RouteState.lastVisitedRoute);

  return router.createUrlTree([appRoute]);
};
